import { Breadcrumbs } from '@digital-retail/falabella-ui-cross-components';
import { isStandalone } from '@digital-retail/store-manager';
import PropTypes from 'prop-types';
import CMRApertura from '../../../components/CMRApertura/CMRApertura';
import ComboItemsMobile from '../../../components/ComboSection/ComboItemsMobile';
import ImageGallery from '../../../components/ImageGallery/ImageGallery';
import { BREAKPOINTS, SOFTLINE_PARAMS } from '../../../components/ImageGallery/ImageGalleryHelper';
import ProductOutOfStock from '../../../components/ProductOutOfStock/ProductOutOfStock';
import ProductSpecificationsAccordion from '../../../components/ui/ProductSpecificationsAccordion/ProductSpecificationsAccordion';
import constants from '../../../config/constants';
import { RatingAndReviews } from '../../../external_dependencies/ratingAndReviews/RatingAndReviews';
import { withApplicationContext } from '../../../utils/ApplicationContext';
import { withLabels } from '../../../utils/LabelsContext';
import _ from '../../../utils/LodashImports';
import { withProduct } from '../../../utils/ProductContext';
import { withUser } from '../../../utils/UserContext';
import { getVariant } from '../../../utils/variant';
import ConnectTab from '../../HardLineProductContainer/ConnectTab/ConnectTab';
import Helpline from '../../Helpline/HelpLine';
import ProductSpecification from '../../ProdctSpecifications/ProductSpecifications';
import ReturnPolicy from '../../ReturnPolicy/ReturnPolicy';
import PDPBasicInfoMobile from './containers/PDPBasicInfoMobile/PDPBasicInfoMobile';
import SoftLineMobileStyles from './SoftLineMobile.style';

const PDPMobile = ({
  product,
  labels,
  crop,
  headlineImageHeight,
  headlineImageWidth,
  zoomSize,
  isVendorLogin,
  appCtx,
}) => {
  const {
    isOutOfStock,
    breadCrumb,
    name: productName,
    variants,
    currentVariant,
    cmrBannerActive = true,
    darSectionActive,
  } = product;

  const variant = getVariant(variants, currentVariant);
  const comboData = _.get(variant, 'comboData', null);
  const { prices, cmrSavings } = variant;
  const { store } = appCtx;
  const isSoCom = appCtx.store === constants.STORES.so_com;
  const isStandaloneStore = isStandalone({ store });
  const showCMRApertura = isSoCom
    ? _.get(appCtx, 'siteConfig.toggles.isCMRAperturaEnabledForSoCom', false)
    : _.get(appCtx, 'siteConfig.toggles.isCMRAperturaEnabled', false);
  const isModernLineContainerEnabled = !!appCtx?.siteConfig?.toggles?.isModernLineContainerEnabled;

  const originalLayoutType = product.layoutType || constants.DEFAULT_LAYOUT_TYPE;
  const isSoftlineProduct = originalLayoutType === constants.PRODUCT_CONSTANTS.SOFTLINE;
  const screenWidth = typeof window !== 'undefined' ? window.innerWidth : BREAKPOINTS.DESKTOP_MIN;
  const isMobile = screenWidth <= BREAKPOINTS.MOBILE_MAX;
  const isTablet = screenWidth >= BREAKPOINTS.TABLET_MIN && screenWidth <= BREAKPOINTS.TABLET_MAX;

  const getImageDimensions = () => {
    if (isSoftlineProduct) {
      if (isMobile) {
        return SOFTLINE_PARAMS.IMAGE_DIMENSIONS.MOBILE;
      }
      if (isTablet) {
        return SOFTLINE_PARAMS.IMAGE_DIMENSIONS.TABLET;
      }
      return SOFTLINE_PARAMS.IMAGE_DIMENSIONS.DESKTOP;
    }
    return {
      width: headlineImageWidth,
      height: headlineImageHeight,
      zoomSize,
    };
  };

  const { width: imageWidth, height: imageHeight, zoomSize: imageZoomSize } = getImageDimensions();

  const productSpecification = <ProductSpecification layoutType={constants.PRODUCT_CONSTANTS.SOFTLINE} />;
  const productSpecificationView = () => {
    if (!isVendorLogin) return productSpecification;

    const tabData = [
      {
        title: (flag) => (
          <div className="flex">
            {!flag ? <span className="icon internet-icon-active" /> : <span className="icon internet-icon-disabled" />}
            <p>INTERNET</p>
            <style jsx>{SoftLineMobileStyles}</style>
          </div>
        ),
        content: () => productSpecification,
      },
      {
        title: (flag) => (
          <div className="flex">
            {!flag ? <span className="icon tienda-active" /> : <span className="icon tienda-disabled" />}
            <p>TIENDA</p>
            <style jsx>{SoftLineMobileStyles}</style>
          </div>
        ),
        content: () => <ProductSpecification layoutType={constants.PRODUCT_CONSTANTS.SOFTLINE} currentTab="Tienda" />,
      },
    ];
    return <ConnectTab tabData={tabData} />;
  };

  if (isOutOfStock) {
    return (
      <div className="pdp-body">
        <div className="pdp-body-container">
          <Breadcrumbs
            items={breadCrumb}
            productName={productName}
            isPdpPage
            tenant={appCtx.regionCode}
            host={appCtx.host}
            path={appCtx.url}
          />
          <div className="pdp-container out-of-stock">
            <section className="pdp-detail-section oos-wrapper">
              <ProductOutOfStock />
            </section>
            <div className="headline-image-and-details">
              <section className="pdp-image-section">
                {/* modify this component for PDP image view */}
                <ImageGallery />
              </section>
              <section className="pdp-detail-section">
                <PDPBasicInfoMobile product={product} labels={labels} />
                {productSpecificationView()}
              </section>
            </div>
            <div className="rating_summary-wrapper">
              <RatingAndReviews />
            </div>
            {comboData && (
              <div className="combo-wrapper">
                <ComboItemsMobile comboData={comboData} />
              </div>
            )}
          </div>
        </div>
        <style jsx>{SoftLineMobileStyles}</style>
      </div>
    );
  }

  return (
    <div className="pdp-body">
      <div className="pdp-body-container">
        <Breadcrumbs
          items={breadCrumb}
          productName={productName}
          isPdpPage
          tenant={appCtx.regionCode}
          host={appCtx.host}
          path={appCtx.url}
        />
        <div className="pdp-container">
          {isStandaloneStore && (
            <section className="pdp-detail-section">
              <PDPBasicInfoMobile product={product} labels={labels} />
            </section>
          )}
          <section className="pdp-image-section">
            <ImageGallery
              crop={crop}
              headlineImageHeight={imageHeight}
              headlineImageWidth={imageWidth}
              zoomSize={imageZoomSize}
              deviceType="mobile"
            />
          </section>
          {!isStandaloneStore && (
            <section className="pdp-detail-section">
              <PDPBasicInfoMobile product={product} labels={labels} />
            </section>
          )}
          <section className="pdp-detail-section">
            {isOutOfStock ? <ProductOutOfStock /> : productSpecificationView()}
          </section>
        </div>
        <ReturnPolicy returnPolicy={product.returnPolicy} darSectionActive={darSectionActive} />
        <Helpline product={product} />
        {isModernLineContainerEnabled && (
          <section className="pdp-accordion-section">
            <ProductSpecificationsAccordion product={product} labels={labels} appCtx={appCtx} />
          </section>
        )}
        {showCMRApertura && cmrBannerActive && <CMRApertura prices={prices} cmrSavings={cmrSavings} />}
      </div>
      <style jsx>{SoftLineMobileStyles}</style>
    </div>
  );
};

PDPMobile.defaultProps = {
  crop: { x: 248, y: 0 },
  headlineImageHeight: 1500,
  headlineImageWidth: 1500,
  zoomSize: { x: 1004, y: 1500 },
};
PDPMobile.propTypes = {
  product: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  crop: PropTypes.object,
  headlineImageHeight: PropTypes.number,
  headlineImageWidth: PropTypes.number,
  zoomSize: PropTypes.object,
  isVendorLogin: PropTypes.bool.isRequired,
  appCtx: PropTypes.object.isRequired,
};

export { PDPMobile };
export default withUser(withProduct(withLabels(withApplicationContext(PDPMobile))));
